<template lang="pug">
v-dialog( v-model="display" persistent  width="35%" )
	v-row(no-gutters v-if="item" align="center" justify="space-around" class="tw-bg-white tw-py-4")
		v-col(cols="8")
			v-row(dense )
				v-col
					div(class=" text-h6 text-center")
						span() Are you sure you want to delete
					div(class=" text-center pt-3 ")
						span() {{ item.name }}
			v-row( dense align="center" justify="space-around" class="tw-pt-8")
				v-col(cols="auto")
					v-row(dense)
						v-col
							v-btn( @click="cancel" outlined text color="secondary" )
								span() cancel
						v-col
							v-btn( @click="deleteItem" elevation="0"  color="error" )
								span() delete
								
						
	
</template>
<script>
export default {
	computed: {
		display () {
			return (this.$store.getters['delete'] ? true : false)
		},
		item () {
			return this.$store.getters['delete']
		}
	}, 
	methods: {
		deleteItem(){
			this.$store.dispatch(this.item.item_type + '/destroy', this.item.id)
			.then((response) => {
				this.$store.commit('SET_DELETE', null)
				this.$router.go(-1)
			})
			.catch((error) => {
				this.$store.commit('SET_ERROR', error, {root: true})
			})

		},
		cancel(){
			this.$store.commit['']
			this.$store.commit('SET_DELETE', null);
		}
	},
}
</script>